@use 'variables' as *;

.chartContainer {
  // border-radius: 10px;
  padding: 30px 35px 0px 0px;
  padding-top: 40px;
  // background-color: $backgroundGrey;
  border-radius: $borderRadius;
  position: relative;
  .disableMouse {
    display: none;
    @media screen and (max-width: 600px) {
      width: 100%;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: 999;
      display: block;
      position: absolute;
    }
  }
  @media screen and (max-width: 600px) {
    padding: 30px 14px 0px 0px;
    :global(.VictoryContainer) {
      pointer-events: none !important;
      touch-action: auto !important;
    }
    tspan {
      font-size: 17px !important;
    }
  }
  svg {
    overflow: visible;
    g {
      overflow: visible;
    }
  }
  h3 {
    font-size: 16px;
  }
  .chartLegend {
    float: right;
    span {
      margin-left: 15px;
      display: inline-block;
      transform: translateY(-10px);
      font-size: 15px;
      @media screen and (max-width: 600px) {
        font-size: 13px;
        transform: translateY(0px);
      }
      &:before {
        margin-right: 5px;
        content: ' ';
        height: 10px;
        display: inline-block;
        width: 10px;
        background-color: #000;
        border-radius: 50%;
      }
      &:first-child {
        &:before {
          background-color: $yellow;
        }
      }
    }
  }
}
.chartContainerTight {
  padding: 0px;
  overflow: hidden;
  border-radius: 50px;
  // background-color: $backgroundGrey;
  svg {
    overflow: visible;
    g {
      overflow: visible;
    }
  }
}
